import { API_ENDPOINTS, apiService } from "../api";
import type {
  OpenShareLinkResponse,
  ShareLink,
  ShareLinkKind,
  StoryShareLinks,
  UpdateShareLinkRequest,
} from "./shareLinks.types";

export const fetchStoryShareLinks = (storyId: string): Promise<StoryShareLinks> =>
  apiService.get<StoryShareLinks>(API_ENDPOINTS.shareLinks.list(storyId));

export const updateShareLink = (
  storyId: string,
  kind: ShareLinkKind,
  body: UpdateShareLinkRequest,
): Promise<ShareLink> =>
  apiService.put<ShareLink>(API_ENDPOINTS.shareLinks.item(storyId, kind), body);

export const resetShareLink = (storyId: string, kind: ShareLinkKind): Promise<ShareLink> =>
  apiService.post<ShareLink>(API_ENDPOINTS.shareLinks.reset(storyId, kind), {});

/** Public (no auth): exchanges a slug for a viewer token and the link's options. */
export const openShareLink = (slug: string): Promise<OpenShareLinkResponse> =>
  apiService.post<OpenShareLinkResponse>(API_ENDPOINTS.shareLinks.open(slug), {});
